import { desiredMediaState } from "./state";
import { saveDevicesInStorrage } from "./devices";
import { needSync, sessionActive } from "./pipe";
import { saveBlur, evictBackgroundSource } from "./videoBlur";
import { clearCustomBackground } from "./customBackground";
import { speakMicroOff, speakMicroOn } from "../speakOnMicroOffNotify";
import { log } from "../../utils/logger";
import { resumeAudioContext } from "../audioCtx";
import { BACKGROUND_BLUR_STRENGTHS } from "./state";
import type { BackgroundEffect } from "./state";

// Действия пользователя меняют только желаемое состояние; фактическое
// приводится к нему проходами пайплайна (needSync). Все мутации изолированы
// рамками сессии: после cleanup (до нового init) запоздавшие события старой
// сессии не должны влиять на желаемое состояние следующей.
export const mediaActions = {
  cameraOn() {
    log.debug('cameraOn')
    if (!sessionActive.value) return
    if(desiredMediaState.cameraEnabled) return
    desiredMediaState.cameraEnabled = true;
    needSync()
  },
  cameraOff() {
    log.debug('cameraOff')
    if (!sessionActive.value) return
    if(!desiredMediaState.cameraEnabled) return
    desiredMediaState.cameraEnabled = false;
    needSync()
  },
  microOn() {
    log.debug('microOn')
    if (!sessionActive.value) return
    if(desiredMediaState.microEnabled) return
    desiredMediaState.microEnabled = true;
    resumeAudioContext();
    speakMicroOn()
    needSync()
  },
  microOff() {
    log.debug('microOff')
    if (!sessionActive.value) return
    if(!desiredMediaState.microEnabled) return
    desiredMediaState.microEnabled = false;
    speakMicroOff()
    needSync()
  },
  setCameraDevice(deviceId: string) {
    log.debug('setCameraDevice', deviceId)
    if (!sessionActive.value) return
    if(desiredMediaState.cameraDevice === deviceId) return
    desiredMediaState.cameraDevice = deviceId;
    saveDevicesInStorrage()
    needSync()
  },
  setMicroDevice(deviceId: string) {
    log.debug('setMicroDevice', deviceId)
    if (!sessionActive.value) return
    if(desiredMediaState.microDevice === deviceId) return
    desiredMediaState.microDevice = deviceId;
    resumeAudioContext();
    saveDevicesInStorrage()
    needSync()
  },
  setAudioDevice(deviceId: string) {
    log.debug('setAudioDevice', deviceId)
    if (!sessionActive.value) return
    if(desiredMediaState.audioDevice === deviceId) return
    desiredMediaState.audioDevice = deviceId;
    saveDevicesInStorrage()
    needSync()
  },
  resetCameraDevice() {
    log.debug('resetCameraDevice')
    if (!sessionActive.value) return
    if(!desiredMediaState.cameraDevice) return
    desiredMediaState.cameraDevice = null
    saveDevicesInStorrage()
    needSync()
  },
  resetMicroDevice() {
    log.debug('resetMicroDevice')
    if (!sessionActive.value) return
    if(!desiredMediaState.microDevice) return
    desiredMediaState.microDevice = null
    saveDevicesInStorrage()
    needSync()
  },
  resetAudioDevice() {
    log.debug('resetAudioDevice')
    if (!sessionActive.value) return
    if(!desiredMediaState.audioDevice) return
    desiredMediaState.audioDevice = null
    saveDevicesInStorrage()
    needSync()
  },
  setBackgroundEffect(effect: BackgroundEffect) {
    log.debug('setBackgroundEffect', effect)
    if (!sessionActive.value) return
    if(JSON.stringify(desiredMediaState.backgroundEffect) === JSON.stringify(effect)) return
    desiredMediaState.backgroundEffect = effect
    if(effect.kind === 'blur') {
      desiredMediaState.blurSize = BACKGROUND_BLUR_STRENGTHS[effect.strength]
    }
    saveBlur()
    needSync()
  },
  setBlurSize(size: number) {
    log.debug('setBlurSize', size)
    if (!sessionActive.value) return
    if(desiredMediaState.blurSize === size) return
    desiredMediaState.blurSize = size
    needSync()
  },
  setCustomBackgroundImage(src: string) {
    log.debug('setCustomBackgroundImage')
    if (!sessionActive.value) return
    if(desiredMediaState.customBackground === src) return
    if(desiredMediaState.customBackground) {
      evictBackgroundSource(desiredMediaState.customBackground)
      URL.revokeObjectURL(desiredMediaState.customBackground)
    }
    desiredMediaState.customBackground = src
    desiredMediaState.backgroundEffect = { kind: 'custom' }
    saveBlur()
    needSync()
  },
  async removeCustomBackground() {
    log.debug('removeCustomBackground')
    if (!sessionActive.value) return
    evictBackgroundSource(desiredMediaState.customBackground)
    await clearCustomBackground()
    // cleanup мог пройти, пока удалялось изображение из IDB.
    if(!sessionActive.value) return
    if(desiredMediaState.backgroundEffect.kind === 'custom') {
      desiredMediaState.backgroundEffect = { kind: 'none' }
      saveBlur()
      needSync()
    }
  },
  /**
   * Запросить камеру при открытии настроек
   */
  requestCameraOnSettings(val: boolean) {
    log.debug('requestCameraOnSettings', val)
    if (!sessionActive.value) return
    if(desiredMediaState.cameraOnSettings === val) return
    desiredMediaState.cameraOnSettings = val
    needSync()
  }
}
